import { MainInner } from "@/styles/global";
import React from "react";

import S from "./ContactBlock.styled";
import useContactData from "./useContactData";
import { AnimationOnScroll } from "react-animation-on-scroll";

export interface Props {
  contact: {
    contact_info: {
      contactInfoTitle: string;
      contactInfoEmail: string;
      contactInfoName: string;
      contactInfoPhone: string;
    };
  }[];
  title: string;
  animation: string;
}

const ContactBlock: React.FC<Props> = ({ animation, contact, title }) => {
  const contactData = useContactData();

  const RenderContacts = ({ contact }: any) =>
    contact.map((contact: any, i: number) => {
      const {
        contactInfoEmail,
        contactInfoName,
        contactInfoTitle,
        contactInfoPhone,
      } = contact.contact_info;
      return (
        <S.Contact key={i}>
          <S.Name>{contactInfoName}</S.Name>
          <S.Position>{contactInfoTitle}</S.Position>
          <S.Email href={`mailto:${contactInfoEmail}`} target="_blank">
            {contactInfoEmail}
          </S.Email>
          {contactInfoPhone && (
            <S.Email href={`tel:${contactInfoPhone}`} target="_blank">
              {contactInfoPhone}
            </S.Email>
          )}
        </S.Contact>
      );
    });

  return (
    <AnimationOnScroll
      animateIn={`animate__${animation}`}
      animateOnce={true}
      initiallyVisible={animation == "none" ? true : false}
      duration={animation === "none" ? 0 : 1}
      delay={animation === "none" ? 0 : 100}
    >
      <S.Container>
        <MainInner>
          <S.Title>{title}</S.Title>
          <S.Contacts>
            {contact ? (
              <RenderContacts contact={contact} />
            ) : (
              <RenderContacts contact={contactData} />
            )}
          </S.Contacts>
        </MainInner>
      </S.Container>
    </AnimationOnScroll>
  );
};

export default ContactBlock;
